export function shouldFetchInitialWorkOrderNum(
  draperyOrderId?: number,
  workOrderId?: number
): boolean {
  return Number(draperyOrderId || 0) === 0 && !(Number(workOrderId || 0) > 0);
}
